import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import logo from "@/assets/jbnl-logo.png";
import { cn } from "@jbnl/shared-ui";

/** Fixed artwork: place it, never redraw or recolour it. */
export function Logo({ className, ...props }: ComponentProps<"img">) {
  const { t } = useTranslation();

  return <img src={logo} alt={t("logoAlt")} className={cn("w-auto select-none", className)} {...props} />;
}
